import { InjectionToken } from '@angular/core';
import { NgxFormModuleConfig } from '../types/ngx-form-module-config';

export const NGX_FORM_MODULE_CONFIG = new InjectionToken<NgxFormModuleConfig>(
  'NGX_FORM_MODULE_CONFIG',
);
